/*
 * fa-geo.js — Freak Athlete visitor-country detection (replaces ipgeolocation.io, 2026-10-21).
 *
 * Drop-in for the ipgeolocation.io jQuery SDK: exposes the same global
 * `_ipgeolocation.getGeolocation(callback, apiKey)` so every existing caller
 * (custom.js <global-redirect>, sections/fa-guide-geo.liquid, and the theme.js copies
 * Replo baked into its page chunks) keeps its popup, cookie and timing logic unchanged.
 * Only the data source differs: Shopify's own, free, per-visitor
 * /browsing_context_suggestions.json (detected_values.country.handle = ISO-3166 alpha-2).
 *
 * Response shape mirrors the fields the callers read from ipgeolocation.io:
 *   country_code2  "US"            country_name  "United States"
 *   country_tld    ".us"  (ccTLD = "." + iso lowercased; GB -> ".uk", as ipgeolocation returned)
 * Failure (network error, non-200, no country) -> callback({message}) with NO country_tld,
 * which every caller already treats as "no geo signal -> show nothing".
 */
var _ipgeolocation = window._ipgeolocation = (function () {
  var CACHE_KEY = 'fa_geo_country_v1';
  var pending = null;

  function toResponse(iso, name) {
    iso = String(iso || '').toUpperCase();
    if (!/^[A-Z]{2}$/.test(iso)) return null;
    var tld = iso === 'GB' ? '.uk' : '.' + iso.toLowerCase();
    return { country_code2: iso, country_name: name || iso, country_tld: tld };
  }

  function detect() {
    if (pending) return pending;
    pending = new Promise(function (resolve) {
      try {
        var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
        if (cached && cached.country_tld) return resolve(cached);
      } catch (e) {}
      var done = false;
      var timer = setTimeout(function () { if (!done) { done = true; resolve(null); } }, 8000);
      fetch('/browsing_context_suggestions.json', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var c = j && j.detected_values && j.detected_values.country;
          var res = c ? toResponse(c.handle, c.name || j.detected_values.country_name) : null;
          if (res) { try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(res)); } catch (e) {} }
          if (!done) { done = true; clearTimeout(timer); resolve(res); }
        })
        .catch(function () { if (!done) { done = true; clearTimeout(timer); resolve(null); } });
    });
    return pending;
  }

  return {
    getGeolocation: function (callback) {
      detect().then(function (res) {
        if (typeof callback !== 'function') return;
        callback(res ? { country_code2: res.country_code2, country_name: res.country_name, country_tld: res.country_tld }
                     : { message: 'fa-geo: visitor country not detected' });
      });
    },
    toResponse: toResponse,
    // SDK no-ops kept so any stray caller of the old API never throws.
    enableSessionStorage: function () {}, makeAsyncCallsToAPI: function () {}, setIPAddress: function () {},
    setFields: function () {}, setExcludes: function () {}, setLanguage: function () {},
    setTimeZone: function () {}, setCoordinates: function () {},
    getTimezone: function (cb) { if (typeof cb === 'function') cb({ message: 'fa-geo: timezone not supported' }); }
  };
})();
